import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NotificationSettingDto, ProfileDto} from '../../../api/wallet-api.generated';
import {GlobalConstants} from '../../../shared/common/constants';
import {BalanceTypes} from '../../../shared/enums/enums';

@Component({
  selector: 'app-profile-notifications',
  templateUrl: './profile-notifications.component.html',
  styleUrls: ['./profile-notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileNotificationsComponent implements OnInit {

  @Input() public readonly profile: ProfileDto;

  @Input() public readonly isEthDisabled: boolean;

  @Input() public readonly index: number;

  @Output() updateSettings: EventEmitter<NotificationSettingDto> = new EventEmitter<NotificationSettingDto>();

  public settings: NotificationSettingDto;

  public defaultSettings: NotificationSettingDto;

  public currencyCodePrefix = GlobalConstants.currencyCodePrefix;

  public balanceTypes = BalanceTypes;

  public edited = false;

  constructor() {
  }

  @Input() set notificationSettings(settings: NotificationSettingDto[]) {
    if (settings?.length) {
      this.settings = settings.find((item) => this.profile?.id === item?.profileId);
      this.defaultSettings = {...this.settings};
    }
  };

  ngOnInit(): void {
  }

  onTypeChange($event) {
    this.edited = true;
  }

  cancel($event) {
    this.settings = {...this.defaultSettings};
    this.edited = false;
  }

  onSave() {
    this.updateSettings.emit(this.settings);
    this.edited = false;
  }

}
